import type { RefObject } from "react"
import type { SessionThreadModel } from "../store/SessionThreadModel"
import type { TaskSessionDebugInfo } from "../store/TaskModel"
import type { TaskTimelineNavigationTarget } from "../timeline/taskTimelineTypes"
import type { ThreadActivity } from "./thread/ThreadActivityBar"
import { ThreadView } from "./thread/ThreadView"

interface SessionThreadViewProps {
    model: SessionThreadModel
    taskId: string
    taskSessions?: readonly TaskSessionDebugInfo[]
    activity?: ThreadActivity | null
    scrollElementRef?: RefObject<HTMLElement | null>
    initialScrollToBottom?: boolean
    timelineNavigationTarget?: TaskTimelineNavigationTarget | null
}

export function SessionThreadView(props: SessionThreadViewProps): JSX.Element {
    return <ThreadView {...props} activity={props.activity ?? null} />
}
